import BaseAppService from 'pk/service/AppService'

export default class AppService extends BaseAppService {
}
